var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultCarrier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3006 32.5L32.3006 28.2C31.0006 27.1 30.2006 25.5 30.0006 23.7L29.6006 19.6H30.2006L32.5006 18.8C33.5006 18.5 34.4006 18 35.2006 17.5L37.4006 16.1L39.4006 17.6C40.1006 18.1 40.9006 18.6 41.8006 19L45.2006 20.5L44.9006 23.7C44.7006 25.5 43.9006 27.1 42.5006 28.2L37.3006 32.5ZM31.0006 20.7L31.3006 23.6C31.4006 25 32.1006 26.3 33.2006 27.3L37.4006 30.9L41.6006 27.3C42.7006 26.4 43.4006 25.1 43.5006 23.6L43.7006 21.3L41.2006 20.1C40.3006 19.7 39.4006 19.2 38.6006 18.6L37.3006 17.6L35.9006 18.5C35.0006 19.1 34.0006 19.6 32.9006 20L31.0006 20.7Z",
    fill: "#24293D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4005 22.1L37.0005 26.4L34.5005 23.9H35.8005L37.0005 25.1L40.1005 22.1H41.4005Z",
    fill: "#24293D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0006 42.4H18.6006V7.69998L38.0006 5.59998V14.5H36.7006V6.99998L19.9006 8.79998V41.2H36.7006V34.6H38.0006V42.4Z",
    fill: "#24293D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9004 42.4H3.40039V17.1L19.9004 14.9V21.7H18.6004V16.4L4.60039 18.2V41.2H18.6004V36.5H19.9004V42.4Z",
    fill: "#24293D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3004 23.2999H8.90039V24.4999H14.3004V23.2999Z",
    fill: "#24293D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3004 27.2999H8.90039V28.4999H14.3004V27.2999Z",
    fill: "#24293D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3004 31.2999H8.90039V32.4999H14.3004V31.2999Z",
    fill: "#24293D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3004 35.2999H8.90039V36.4999H14.3004V35.2999Z",
    fill: "#24293D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCarrier);
export default __webpack_public_path__ + "static/media/defaultCarrier.21803e32c91c418b6eb203e987fa6d36.svg";
export { ForwardRef as ReactComponent };